import { Injectable } from "@angular/core";

declare const newrelic: any;

@Injectable({ providedIn: 'root' })
export class NewRelicService {

  setGlobalAttributes(attrs: Record<string, string | number | boolean>) {
    if (typeof newrelic !== 'undefined') {
      Object.entries(attrs).forEach(([key, value]) => {
        newrelic.setCustomAttribute(key, value);
      });
    }
  }
}
